export const isEmpty = (obj: any): boolean => {
  if (!obj) return true;
  if (obj === null || obj === undefined || obj === "") return true;
  if (Array.isArray(obj)) return obj.length === 0;
  return Object.entries(obj).length === 0 && obj.constructor === Object;
};
